import { forwardRef } from 'react';
import { createPortal } from 'react-dom';

import classNames from 'classnames';

type ModalProps = {
  children: React.ReactNode;
  onClose: () => void;
  className?: string;
};

const Modal = forwardRef<HTMLDialogElement, ModalProps>(({ children, onClose, className }, ref) => {
  return createPortal(
    <dialog
      ref={ref}
      onClick={(event) => {
        if (event.target === event.currentTarget) {
          onClose();
        }
      }}
      className={classNames('backdrop:bg-black backdrop:bg-opacity-50', className)}
    >
      {children}
    </dialog>,
    document.getElementById('modal-root')!
  );
});

export default Modal;
